import React from "react";
import { Paper, Typography, Box, Chip } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import StorefrontIcon from "@mui/icons-material/Storefront";

const OrderPaymentSummary = ({ payment, meta }) => {
  if (!payment) return null;

  const {
    paymentMethod,
    receiptNumber,
    stripeReceiptNumber,
    stripePaymentIntent,
  } = payment;

  const paymentType = paymentMethod?.type || "";
  const brand = paymentMethod?.brand || "";
  const last4 = paymentMethod?.last4 || "";
  const employeeName = meta?.createdByEmployeeName || null;

  const renderPaymentMethod = () => {
    if (!paymentMethod) return null;

    if (paymentType === "card" || paymentType === "stripe_card") {
      return (
        <Chip
          icon={<CreditCardIcon />}
          label={`Paid with ${brand} ••••${last4}`}
          sx={{
            mt: 1,
            backgroundColor: "grey.100",
            border: "1px solid",
            borderColor: "primary.main",
            fontWeight: "bold",
            fontSize: "0.7rem",
            px: 0.5,
          }}
        />
      );
    }

    if (paymentType === "in_store_pos") {
      return (
        <Chip
          icon={<StorefrontIcon />}
          label="Paid In-Store (POS)"
          sx={{
            mt: 1,
            backgroundColor: "grey.100",
            border: "1px solid",
            borderColor: "secondary.main",
            fontWeight: "bold",
            fontSize: "0.7rem",
            px: 0.5,
          }}
        />
      );
    }

    return null;
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 3,
        minHeight: 150,
        backgroundColor: {
          xs: "transparent",
          print: "transparent",
          sm: "#f9f9f9",
        },
      }}
      className="print-section">
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Payment Details
      </Typography>

      {/* Payment method chip */}
      <Box mb={2}>
        {renderPaymentMethod()}

        {/* Stripe Payment Details */}
        {(paymentType === "card" || paymentType === "stripe_card") && (
          <>
            {stripeReceiptNumber ? (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Receipt #: <strong>{stripeReceiptNumber}</strong>
              </Typography>
            ) : stripePaymentIntent ? (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Payment ID: <strong>{stripePaymentIntent}</strong>
              </Typography>
            ) : null}

            <Typography variant="body2" sx={{ mt: 1 }}>
              Placed Online
            </Typography>
          </>
        )}

        {/* In-Store Payment Details */}
        {paymentType === "in_store_pos" && (
          <>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Receipt #: <strong>{receiptNumber || "N/A"}</strong>
            </Typography>

            {employeeName && (
              <Typography variant="body2">
                Served By: <strong>{employeeName}</strong>
              </Typography>
            )}
          </>
        )}
      </Box>
    </Paper>
  );
};

export default OrderPaymentSummary;
